export const environment = {
  production: true,
  apiUrl: "/api",
  version: "VERSION",
  // TODO: Add sentry dns and environment name
  sentry: "https://d2709466d7d94feebf399a3957b22bb7@o464457.ingest.sentry.io/5550253",
  name: "production",
};
